import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { useCreatePlace } from '../../../context/CreatePlaceContext'
import Button from '../../shared/Button'
import CounterWithlabelin from '../../shared/CounterWithlabelin'
import Input from '../../shared/Input'
import InputWithlabelin from '../../shared/InputWithlabelin'

const CreateStep8 = ({prevStep,nextStep}) => {
  const { updatePlaceDetail, createInfoData,apiUpdateResideces ,setIsEditPlaceCompleter} = useCreatePlace();

    const {
        formState: { errors, isValid },
        control,
        handleSubmit
      } = useForm({
        defaultValues:{
          peak_day:createInfoData.stepTwelve.peak_day,
          weekend:createInfoData.stepTwelve.weekend,
          in_week:createInfoData.stepTwelve.in_week,
          per_extra_person:createInfoData.stepTwelve.per_extra_person
        }
      });
      const onSubmit = data=>{
        updatePlaceDetail("stepTwelve",{
          peak_day: data.peak_day,
          weekend: data.weekend,
          in_week: data.in_week,
          per_extra_person:data.per_extra_person
        })
        nextStep()
      }
  const {id}=useParams()
  const update = (data) => {
    updatePlaceDetail("stepTwelve",{
      peak_day: data.peak_day,
      weekend: data.weekend,
      in_week: data.in_week,
      per_extra_person:data.per_extra_person
    })
       setIsEditPlaceCompleter(true);
    
      
  };
  return (
    <div className='createsteps'>
          <h2>قیمت گذاری کلی</h2>
      <p>
      قیمت اجاره اقامتگاه خود را به ازای هر شب برای روز های وسط هفته ( شنبه تا چهار شنبه ) ، آخر هفته ( پنحشنبه و جمعه ) ، روز های پیک ( روز های شلوغ ، اعیاد و تعطیلات خاص ) را وارد نمایید
      </p>
     <form>
     <div className="createsteps--grid3 mt-[50px]">
      <InputWithlabelin
         name="in_week"
         control={control}
         errors={errors}
         placeholder=" مثلا ۵۰۰/۰۰۰"
         label="قیمت وسط هفته"
         labelIn="تومان"
         className="seconadary-input"
         type='number'
         register={{
          required: " قیمت وسط هفته  اجباری است"
        }}
        />
        <InputWithlabelin
         name="weekend"
         control={control}
         errors={errors}
         placeholder="مثلا ۶۰۰/۰۰۰"
         label="قیمت آخر هفته"
         labelIn="تومان"
         className="seconadary-input"
         type='number'

         register={{
          required: " قیمت آخر هفته  اجباری است"
        }}
        />
         <InputWithlabelin
         name="peak_day"
         control={control}
         errors={errors}
         placeholder="مثلا ۶۰۰/۰۰۰"
         label="قیمت روز های پیک هفته"
         className="seconadary-input"
         labelIn="تومان"
         type='number'

         register={{
          required: " قیمت روز های پیک هفته اجباری است"
        }}
        />
         <InputWithlabelin
         name="per_extra_person"
         control={control}
         errors={errors}
         placeholder="مثلا ۶۰۰/۰۰۰"
         label="قیمت برای نفرات اضافه"
         className="seconadary-input"
         labelIn="تومان"
         type='number'

         register={{
          required: " قیمت برای نفرات اضافه اجباری است"
        }}
        />
     </div>
     <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
    {id&& <Button varient="primary" onClick={handleSubmit((d) =>update(d))}> 
                بروزرسانی اقامتگاه
              </Button>}
        <Button
          varient="gray"
          onClick={() => {
            prevStep();
          }}
        >
          مرحله قبلی
        </Button>

        <Button onClick={handleSubmit((d) =>onSubmit(d))}  varient="primary" type='submit'>
          مرحله بعدی
        </Button>
      </div>
     </form>
    </div>
  )
}

export default CreateStep8